export const BASE_URL_API = process.env.REACT_APP_BASE_URL_API;
export const AFCONS_VERSION = "1.0.5";
